import { Component } from "@angular/core";

@Component({
  selector: "shared-coming-soon",
  templateUrl: "./coming-soon.component.html",
  styleUrl: "./coming-soon.component.scss",
})
export class ComingSoonComponent {}
